// JavaScript source code
/* eslint-disable */
import React from 'react';
import {
    ShowTitleByDescription,
    BaseFilter,
    validateStaticDataWithCode,
} from './Scaffolding';
import {
    TextField,
    Datagrid,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';
import { EditToolbar } from '../layout/EditToolbar';

export const LanguageLabels = {
    pageTitle: 'Languages',
    singleLabel: 'Language',
    Title: 'Code',
    description: 'Language',
};

export const LanguageList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={LanguageLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField label={LanguageLabels.Title} source="Title" />
                    <TextField
                        label={LanguageLabels.description}
                        source="description"
                    />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const LanguageEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit {...props} title={<ShowTitleByDescription />} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput label={LanguageLabels.Title} source="Title" />
                    <TextInput
                        label={LanguageLabels.description}
                        source="description"
                    />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const LanguageCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm validate={validateStaticDataWithCode}>
            <TextInput label={LanguageLabels.Title} source="Title" />
            <TextInput
                label={LanguageLabels.description}
                source="description"
            />
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

export const LanguageShow = (props) => (
    <Show {...props} title={<ShowTitleByDescription />}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label={LanguageLabels.Title} source="Title" />
            <TextField
                label={LanguageLabels.description}
                source="description"
            />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
